import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'code', label: 'Code' },
  { key: 'name', label: 'Name' },
  { key: 'counterparty_name', label: 'Issuer' },
  { key: 'face_value', label: 'Face Value', align: 'right', type: 'money' },
  { key: 'coupon_rate', label: 'Coupon Rate', align: 'right', type: 'percent' },
  { key: 'ytm', label: 'YTM', align: 'right', type: 'percent' },
  { key: 'duration', label: 'Duration (yrs)', align: 'right' },
  { key: 'maturity_date', label: 'Maturity' },
  { key: 'maturity_bucket', label: 'Maturity Bucket' },
];

export function FixedInterestMaturityReport() {
  return (
    <ReportView
      title="Fixed Interest Maturity Profile"
      description="Every bond/fixed-interest holding with face value, coupon rate, yield to maturity, duration, and a forward-looking maturity bucket."
      endpoint="/reports/investments/fixed-interest-maturity"
      columns={COLUMNS}
      xlsx
    />
  );
}
